import React from "react";

const Disclaimer = ({ onAccept, onReject }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/70">
      <div
        className="w-full max-w-lg p-8 rounded-2xl text-white border"
        style={{
          background:
            "linear-gradient(160deg, #0d1f2d 0%, #071520 100%)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(64,190,180,0.3)",
          boxShadow: "0 0 60px rgba(64,190,180,0.15)",
        }}
      >
        <h2
          className="text-2xl font-bold mb-4 text-center"
          style={{ color: "#40BEB4" }}
        >
          Disclaimer
        </h2>

        <ul className="list-disc pl-6 space-y-2 text-gray-200 mb-8 text-sm">
          <li>Ensure that all details provided are accurate.</li>
          <li>Video KYC requires a stable internet connection.</li>
          <li>Your data is securely stored and processed.</li>
        </ul>

        <div className="flex gap-4 mt-4">
          <button
            onClick={onReject}
            className="flex-1 h-12 rounded-md"
            style={{
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.2)",
              color: "#fff",
              fontWeight: "600",
            }}
          >
            Reject
          </button>

          <button
            onClick={onAccept}
            className="flex-1 h-12 rounded-md"
            style={{
              background:
                "linear-gradient(135deg, #40BEB4, #1a9e94)",
              color: "#071520",
              fontWeight: "700",
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;